import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PortalIcon } from 'utils/baochauTheme';
import { BW_MODAL_TONES } from './constants';

const ALERT_ICONS = {
  info: 'fi fi-rr-info',
  success: 'fi fi-rr-check-circle',
  warning: 'fi fi-rr-triangle-warning',
  danger: 'fi fi-rr-octagon-exclamation',
};

const BWModalAlert = ({ tone = 'info', title, description, children, className }) => (
  <div className={classNames('bw_modal_alert', `bw_modal_alert_${tone}`, className)} role='alert'>
    <PortalIcon icon={ALERT_ICONS[tone]} className='bw_modal_alert_icon' aria-hidden='true' />
    <div>
      {title ? <strong>{title}</strong> : null}
      {description ? <p>{description}</p> : null}
      {children}
    </div>
  </div>
);

BWModalAlert.propTypes = {
  tone: PropTypes.oneOf(BW_MODAL_TONES),
  title: PropTypes.node,
  description: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default BWModalAlert;
